import { DirectionProvider, ThemeProvider, Toaster } from "@st-marketplace/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { TolgeeProvider } from "@tolgee/react";
import { useAtom } from "jotai/react";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";

import { router } from "./main";
import { baseUrlAtom } from "./store/base_api";
import { queryClient } from "./utils/react-query";
import { getTolgee, tolgeeLanguageEffect } from "./utils/tolgee";

import "@st-marketplace/ui/style.css";
import "./index.css";
import "./assets/styles/fonts.css";
import { useTranslation } from "./hooks";
import { useGetPlayersAuctionInit, useGetStatus } from "./services";

export function AppBootstrap() {
	useGetStatus();
	useGetPlayersAuctionInit({});
	return null;
}

export function App() {
	useAtom(tolgeeLanguageEffect);
	useAtom(baseUrlAtom); // Just to show in devtools
	const { isRtl } = useTranslation();

	return (
		<ThemeProvider defaultTheme="system" storageKey="app-theme">
			<DirectionProvider dir={isRtl ? "rtl" : "ltr"}>
				<QueryClientProvider client={queryClient}>
					<AppBootstrap />
					<TolgeeProvider tolgee={getTolgee()} fallback="Loading...">
						<NuqsAdapter>
							<RouterProvider router={router} />
						</NuqsAdapter>
						<Toaster dir={isRtl ? "rtl" : "ltr"} />
					</TolgeeProvider>
				</QueryClientProvider>
			</DirectionProvider>
		</ThemeProvider>
	);
}
